import { render, staticRenderFns } from "./CopyBtn.vue?vue&type=template&id=bbc9fea0"
import script from "./CopyBtn.vue?vue&type=script&lang=js"
export * from "./CopyBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports